import styled from 'styled-components';

const SpendbridgeMain = styled.main`
    .wrapper-children {
        padding: 0px;
    }
`;

export default { SpendbridgeMain };
